import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

export const ActivityModalWrapper = styled.div`
  overflow: auto;
  width: calc(70% - 14px);
  transform: translate(20%, 8%);
  -webkit-transition: all 0.2s ease;
  position: absolute;
  top: 15%;
  z-index: 101;
  padding: 1.5em;
  background: #fff;
  border-radius: 5px;
`

export const ActivityModalHeader = styled.h1`
  text-align: center;
  font-size: 1.3em;
  font-weight: 400;
  margin: 0 0 1.2em;
  padding: 0 1.5em;
  line-height: 1.2;
`

export const ActivityModalBackButton = styled.button`
  background: none;
  border: none;
  display: flex;
  &:hover {
    cursor: pointer;
  }
`

export const ActivityModalBackButtonIcon = styled(FontAwesomeIcon)`
  font-size: 1.5rem;
  color: #005cd9;
`
export const ActivityModalBackButtonText = styled.p`
  padding-left: 8px;
  color: #005cd9;
`

export const NoActivityText = styled.p`
  text-align: center;
  font-size: 1em;
  font-weight: 400;
  margin: 0 0 1.2em;
  padding: 0 1.5em;
  line-height: 1.2;
`

export const Backdrop = styled.div`
  position: fixed;
  z-index: 100;
  width: 102vw;
  left: -1vw;
  height: 102vh;
  top: -1vh;
  background: #000;
  opacity: 0.5;
`

export const ActivityModalList = styled.ul`
  overflow: auto;
  max-height: 500px;
`

export const ActivityCategoryModalListItem = styled.li`
  display: block;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  padding: 1.375em 2.2em 1.375em 5em;
  cursor: pointer;
  color: #2164db;
`

export const ActivityCategoryModalListItemGraphic = styled.div<{
  color?: string
}>`
  position: absolute;
  left: 0;
  top: 0;
  height: 3.75em;
  width: 3.75em;
  text-align: center;
  background: ${({ color }) => color || '#005cd9'};
`

export const ActivityCategoryModalListItemImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  height: 3.75em;
  width: 3.75em;
  text-align: center;
`

export const ActivityCategoryModalListItemLabel = styled.div`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
`

export const ActivityModalListItem = styled.li`
  display: block;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
  padding: 1.375em 2.2em 1.375em 5em;
  cursor: pointer;
  color: #2164db;
`

export const ActivityModalListItemGraphic = styled.div<{ color?: string }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 3.75em;
  width: 3.75em;
  text-align: center;
  background: ${({ color }) => color || '#005cd9'};
`

export const ActivityModalListItemImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  height: 3.75em;
  width: 3.75em;
  text-align: center;
`

export const ActivityModalListItemLabel = styled.div`
  overflow: hidden;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
`
